import { TIME_MASK_ZEROHOUR_ZEROMINUTES } from "../Forms/Constants/TimeConstants";

export interface SupplierHandlingTime {
  SupplierGsdb: string;
  HandlingTime: string;
}

export const defaultSupplierHandlingTime = {
  SupplierGsdb: "",
  HandlingTime: TIME_MASK_ZEROHOUR_ZEROMINUTES,
};
